<template>
  <div>
    <el-steps :active="step">
      <el-step :title="$t('Definir niveles de riesgo')" description=""></el-step>
      <el-step :title="$t('Definir flujos')" description=""></el-step>
      <el-step :title="$t('Registrar')" description=""></el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  name: 'workflowCreateSteps',
  props: ['step'],
};
</script>
